import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MenuItem, TextField } from '@material-ui/core';
import React from 'react';

import { ReasonCode } from 'types/ReasonCodes';
import { getReasonCodes } from 'reducers/reasonCodesDB';
import { REASONS } from 'constants/reasonCodesDB';
import { PosPlugin } from 'plugins/plugin';

type Params = Parameters<Required<PosPlugin>['UISetBulkReturnReasons']>[0];

export default function AllItemsReasonDropdown({
  globalReturnReason,
  applyCodeChange,
}: Params) {
  const { t } = useTranslation('return');
  const returnCodeReasons: ReasonCode[] = useSelector(
    getReasonCodes(REASONS.RETURN),
  );

  if (returnCodeReasons.length <= 0) {
    return null;
  }

  return (
    <TextField
      select
      value={globalReturnReason}
      label={t('options.setReason')}
      variant="outlined"
      margin="normal"
      fullWidth
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        applyCodeChange('all', e.target.value);
      }}
    >
      <MenuItem value="">{t('options.default')}</MenuItem>

      {returnCodeReasons.map(reason => (
        <MenuItem key={reason.reasonID} value={reason.reasonID}>
          {reason.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
